import React from 'react'

const IntentToOfferTemplate = ({ data }) => {
  const {
    studentName,
    companyName,
    roleName,
    signatureName,
    signatureRole,
    signatureInstitute,
    signatureContact
  } = data

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
      <p>Hi {studentName},</p>
      
      <p style={{ paddingTop: '8px' }}>
        We are happy to inform you that you have been shortlisted for the role of {roleName}. You will soon receive an official offer from {companyName}.
      </p>
      
      <p style={{ paddingTop: '10px', paddingBottom: '2px', margin: '0px' }}>Best regards,</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureName}</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureRole}</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureInstitute}</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureContact}</p>
    </div>
  )
}

export default IntentToOfferTemplate
